import { Wizard } from "react-use-wizard";
import Content from "./Content";
import Footer from "./Footer";
import { StepProps } from "./Metamask/MetamaskCreate";
import Wallet from "../../assets/Wallet.svg";
import { ConnectButton, IconWithLabel, Button } from "../Actions";
import { useAccount } from "wagmi";
import { useRouter } from "next/router";

const Success: React.FC<StepProps> = ({ prevState, setFlowState }) => {
  const router = useRouter();
  const { isConnected } = useAccount();
  const connectedState = isConnected ? "connected" : "disconnected";
  const finalContent = {
    disconnected: {
      title: "Almost there!",
      description: " Now, you just need to connect your wallet to our site."
    },
    connected: {
      title: "You’re all set!",
      description: "You can close this page and finish minting."
    }
  };
  return (
    <Wizard
      footer={
        <Footer
          hideFooterOnLastStep
          prevState={prevState}
          setFlowState={setFlowState}
          currentState="initial"
        />
      }>
      <Content
        icon={<Wallet width="48" className="text-coinage-teal" />}
        title={"Make sure you have enough money in your wallet."}
        description={
          "We recommend the price of the NFT, plus 0.02 ETH for the transaction fee."
        }
        tooltipContent={{
          title: "What is this transaction fee?",
          description:
            "People call this transaction fee “gas,” and it sucks. It can fluctuate pretty drastically throughout the day. If it’s more than $30, try coming back later."
        }}
      />
      <Content
        icon={<Wallet width="48" className="text-coinage-teal" />}
        title={finalContent[connectedState].title}
        description={finalContent[connectedState].description}>
        {connectedState === "disconnected" ? (
          <ConnectButton className="mt-4" />
        ) : (
          <Button
            className="mt-4"
            onClick={router.back}
            analyticsProperty="Back to home novice flow"
            modifier="primary">
            <IconWithLabel icon="arrow" label="Back to mint" />
          </Button>
        )}
      </Content>
    </Wizard>
  );
};

export default Success;
